import { useI18n } from '@oneaudi/i18n-context';
import { messages } from './i18n';

export const updateAltWithI18n = (alt: string) => {
  let i18nAlt = '';

  if (alt.includes('front')) {
    if (alt.includes('34')) {
      i18nAlt = useI18n(messages.front_34);
    } else {
      i18nAlt = useI18n(messages.front);
    }
  }

  if (alt.includes('rear')) {
    if (alt.includes('34')) {
      i18nAlt = useI18n(messages.rear_34);
    } else {
      i18nAlt = useI18n(messages.rear);
    }
  }

  if (alt.includes('rim')) {
    i18nAlt = useI18n(messages.wheels_rim);
  }

  if (alt.includes('side')) {
    i18nAlt = useI18n(messages.side);
  }

  if (alt.includes('dashboard')) {
    i18nAlt = useI18n(messages.dashboard);
  }

  return i18nAlt;
};
